import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=4eb81eaa&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"
import style0 from "./Robot.vue?vue&type=style&index=0&id=4eb81eaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb81eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb81eaa')) {
      api.createRecord('4eb81eaa', component.options)
    } else {
      api.reload('4eb81eaa', component.options)
    }
    module.hot.accept("./Robot.vue?vue&type=template&id=4eb81eaa&scoped=true", function () {
      api.rerender('4eb81eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/robot/Robot.vue"
export default component.exports